@use "sass:map";
@use "../../../src/scss/abstracts/utilities";
@use "../../../src/scss/abstracts/breakpoints";

:host {
  display: grid;
  grid-template-columns: 1fr;
  gap: utilities.toRem(20px);
  @media (width >= map.get(breakpoints.$grid-breakpoints, "md")) {
    grid-template-columns: 1fr 1fr 1fr;
    gap: utilities.toRem(8px);
  }
  @media (width >= map.get(breakpoints.$grid-breakpoints, "lg")) {
    gap: utilities.toRem(20px);
  }
  @media (width >= map.get(breakpoints.$grid-breakpoints, "xl")) {
    gap: utilities.toRem(60px);
  }
}

service-card {
  > [slot="content"] > p {
    margin-block-end: utilities.toRem(12px);
    &:last-child {
      margin-block-end: 0;
    }
  }
}
